<template>
  <div class="row mb20">
    <label class="col-xs-12 uppercase align-left weight-600">{{
        $t("Choose delivery method")
      }}</label>
    <div
      class="row col-xs-12 radio-input-wrapper"
    >
      <div
        v-for="delivery in deliveries"
        :key="delivery.value"
        class="radio-input relative flexible mt5"
      >
        <input
          v-model="getActiveDelivery"
          :value="delivery.value"
          :id="delivery.value + '-' + rentType"
          :name="'delivery-' + rentType"
          :disabled="isDisabled"
          type="radio"
        />
        <label :for="delivery.value + '-' + rentType" class="radioStyled">
          <span class="nowrap">{{ delivery.label }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EventBus from '@vue-storefront/core/compatibility/plugins/event-bus'

export default {
  name: "Delivery",
  props: {
    rentType: {
      type: String,
      default: "single",
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: "product/getCurrentProduct",
      getCurrentProductConfiguration: "product/getCurrentProductConfiguration",
      getDeliveries: "calendar/getDeliveries",
      isLogged: "user/isLoggedIn",
      getUserBalance: "user/getBalance",
    }),
    getActiveDelivery: {
      get () {
        return this.$store.state.calendar.delivery;
      },
      set (value) {
        this.updateDelivery(value)
      }
    },
    deliveries() {
      return this.getDeliveries.map((delivery) => ({
        label: this.deliveryBeautifier(delivery),
        value: delivery,
      }));
    },
    isEnoughPoints() {
      return this.getUserBalance >= 1;
    },
    isDisabled() {
      return (
        this.rentType === "subscription" &&
        (!this.isEnoughPoints || !this.isLogged)
      );
    },
  },
  methods: {
    deliveryBeautifier(delivery) {
      return delivery === "showroom"
        ? this.$t("In-store pickup")
        : this.$t("Delivery by courier");
    },
    updateDelivery(value) {
      if (value) this.$store.commit("calendar/updateDelivery", value);
      this.$store.dispatch("calendar/loadCalendarData", {
        sku: this.getCurrentProduct.sku,
      });
      EventBus.$emit('resetCalendarDate')
    },
  },
};
</script>

<style lang="scss" scoped>
.text-none {
  text-transform: none;
}
.nowrap {
  white-space: nowrap;
}
.radio-input {
   flex-basis: 90px;
   label {
    padding: 10px 14px;
    text-align: center;
    border: 1px solid #DCDCDC;
    color: #646464;
    display: block;
    text-transform: uppercase;
    font-size: 13px;
    cursor: pointer;
  }
  input {
    display: none;
    position: absolute;
    top: 3px;
    left: 0;
    &:checked + label {
      box-shadow: 0px 0px 0px 2px #3e3e3e !important;
      color: black;
      background-color: #F5D2D2;
    }
    &:hover,
    &:focus {
      + label {
        box-shadow: 0px 0px 0px 1px #3e3e3e;
      }
    }
    &:disabled + label {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
.flexible {
  &:nth-last-of-type(1){
    padding-left: 8px;
  }
  &:nth-last-of-type(2){
    padding-left: 8px;
    padding-right: 8px;
  }
  &:nth-last-of-type(3){
    padding-right: 8px;
  }
}
</style>
